import { render } from "./PreschoolReportScoreContent.vue?vue&type=template&id=26c7158b&scoped=true&ts=true"
import script from "./PreschoolReportScoreContent.vue?vue&type=script&lang=ts"
export * from "./PreschoolReportScoreContent.vue?vue&type=script&lang=ts"

import "./PreschoolReportScoreContent.vue?vue&type=style&index=0&id=26c7158b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26c7158b"]])

export default __exports__